module.exports = __webpack_public_path__ + "public/images/about-17.93fc727fee07401186e6ea6865f94087.png";